import React from 'react'
import { useNetworkQuality } from './contexts/NetworkQualityContext'
import { NetworkBadge } from './styles'
import { VIDEO_CALL_MEET_TEST_IDS } from './testIds'

export default function NetworkQualityPill() {
  const { connectionStatus, networkMessage } = useNetworkQuality()

  return (
    <NetworkBadge
      data-testid={VIDEO_CALL_MEET_TEST_IDS.networkQuality}
      status={connectionStatus}
      title={networkMessage}
    >
      {networkMessage}
    </NetworkBadge>
  )
}
